"use client";
import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import Button from "@workspace/casino_pages/legacyLayer/legacyUi/Button";
import Content from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/Content";
import useSwitchCurrencyNotification from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/SwitchCurrencyNotification/hooks/useSwitchCurrencyNotification";

const SwitchCurrencyNotification: FC<NotificationViewProps> = (props) => {
  const { onClose, context } = props;
  const { handleCurrencyChange, values } = useSwitchCurrencyNotification(props);
  return (
    <Content onClose={onClose} testId="switch-currency-notification">
      <div className="grid cursor-pointer gap-2 pt-6 ltr:text-left rtl:text-right">
        <h4 className="text-lg/6 text-black">
          <Translation
            translations={context.translations}
            id="casino.switch_currency_to_play_game"
          />
        </h4>
        <p className="text-muted-foreground">
          <Translation
            translations={context.translations}
            id="casino.in_order_to_play_game"
            values={values}
          />
        </p>
        <div className="grid grid-flow-col grid-cols-[50%_50%] justify-between gap-4">
          <Button variant="primary" onClick={handleCurrencyChange}>
            <Translation
              translations={context.translations}
              id="button.switch"
            />
          </Button>
          <Button variant="tertiary" onClick={onClose}>
            <Translation translations={context.translations} id="general.no" />
          </Button>
        </div>
      </div>
    </Content>
  );
};

export default SwitchCurrencyNotification;
